import React, { useRef, useState } from 'react';
import './style.scss';
import CardsListListCardCarousel from './carouselCard';
import CardsListListCard from './card';
import clsx from 'clsx';
import { v1 as uuid } from 'uuid';
import CarouselSlider from '../../../Shared/components/Carousel/shared/slider';
import { SwiperSlide } from 'swiper/react/swiper-react.js';
const CardsListListView = ({
  language,
  sizeX,
  darkMode,
  cards,
  selectCard,
  cardsSelected,
  selectable,
  rewardsOpenedFor,
  setRewardsOpenedFor,
  openRewards,
  dontShowCompare,
  t,
}) => {
  const [cardInfo, sertCardInfo] = useState(defaultCardsState);

  const defaultCardsState = {
    shouldRenderRewards: null,
    slideSectionLabel1: null,
    slideSectionLabel2: null,
    slideSectionIcons: null,
    slideSectionDescription: null,
    card: null,
  };

  const contentItemRef = useRef();
  return (
    <>
      {sizeX < 768 && (
        <CarouselSlider
          className={clsx(
            'swiper-with-bottom-padding-animation mobile-css card-list-view-mobile',
            rewardsOpenedFor ? 'opened' : 'closed'
          )}
          slidesPerView="auto"
          lang={language}
          onSlideSwap={() => {
            sertCardInfo(defaultCardsState);
            setRewardsOpenedFor(null);
          }}
          bulletClassName={clsx('carousel-bullet', !darkMode && 'carousel-bullet-light')}
          style={
            rewardsOpenedFor
              ? { paddingBottom: contentItemRef?.current?.clientHeight }
              : { paddingBottom: 50 }
          }
          breakpoints={{
            400: {
              spaceBetween: 8,
            },
            500: {
              spaceBetween: 16,
            },
            768: {
              spaceBetween: 32,
            },
          }}
        >
          {cards.map((card, index) => (
            <SwiperSlide key={uuid()}>
              <CardsListListCardCarousel
                contentItemRef={contentItemRef}
                data={card}
                key={index}
                dontShowCompare={dontShowCompare}
                onSelect={() => selectCard(card)}
                isSelected={cardsSelected.includes(card.id)}
                selectable={selectable}
                rewardsOpened={rewardsOpenedFor === card.id}
                openRewards={() => openRewards(card.id)}
                t={t}
              />
            </SwiperSlide>
          ))}
        </CarouselSlider>
      )}
      <div className={clsx('cards-list-list-cards-wrapper', 'content')}>
        {sizeX >= 768 &&
          cards.map((card, index) => (
            <CardsListListCard
              data={card}
              key={index}
              dontShowCompare={dontShowCompare}
              onSelect={() => selectCard(card)}
              isSelected={cardsSelected.includes(card.id)}
              selectable={selectable}
              rewardsOpened={rewardsOpenedFor === card.id}
              openRewards={() => openRewards(card.id)}
              t={t}
            />
          ))}
      </div>
    </>
  );
};

export default CardsListListView;
